import React from 'react';
import BrandLogo from '../components/utils/BrandLogo';
import '../assets/css/login.css';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config";

function handleLogin(instance) {
    instance.loginRedirect(loginRequest).catch(e => {
        console.error(e);
    });
}

export default function Login() {
    const { instance } = useMsal();

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="d-flex justify-content-center h-100">
                    <div className="card login-card" >
                        <div className="card-header">
                            <h3>Sign In</h3>
                            <div className="d-flex justify-content-end social_icon">
                                <BrandLogo />
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <button className="btn btn-block login_btn" onClick={() => handleLogin(instance)}>NAM Dashboard</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
